import Player from "@vimeo/player";
import { html, render } from "lighterhtml";
import { define } from "wicked-elements";
import anime from "animejs";

import { preventScroll, allowScroll } from "./prevent-scroll";

window.addEventListener("popstate", handle);

function handle() {
  const openElement = document.querySelector(".work-box.open");
  if (openElement) openElement.hide();
  const matchingElement = document.querySelector(
    `.work-box[href="${window.location.href}"]`
  );
  matchingElement?.show?.();
}

define(".work-box", {
  init() {
    this.element.show = this.show.bind(this);
    this.element.hide = this.hide.bind(this);
    this.data = JSON.parse(this.element.dataset.json);
    this.index = 0;
    this.interval = 0;
    this.current = 0;
    this.container = document.createElement("div");
    this.container.className = "slider-container";
    this.container.hidden = true;
    document.body.append(this.container);
    this.render();
  },

  onclick(event) {
    event.preventDefault();
    window.history.pushState(undefined, this.data.title, this.data.url);
    this.show();
  },

  onmouseenter() {
    this.play();
  },

  onmouseleave() {
    this.stop();
  },

  get images() {
    return [...this.element.querySelectorAll(".video-frames img")];
  },

  play() {
    if (!this.images.length > 0) return;
    this.interval = setInterval(() => {
      this.current =
        (this.current + this.images.length + 1) % this.images.length;
      this.images.forEach((image) => image.classList.remove("current"));
      this.images[this.current].classList.add("current");
    }, 300);
  },

  stop() {
    if (!this.images.length > 0) return;
    clearInterval(this.interval);
    this.current = this.images.length - 1;
    this.images.forEach((image) => image.classList.remove("current"));
    this.images[this.current].classList.add("current");
  },

  handleClickClose() {
    history.back();
  },

  show() {
    const vimeo =
      this.container.querySelector("iframe") ||
      this.container.querySelector("[data-vimeo-url]");
    const video = this.container.querySelector("video");
    const player = vimeo ? new Player(vimeo) : video;
    this.container.hidden = false;
    this.container.inert = false;
    anime({
      targets: this.container.querySelector(".fullscreen-slider"),
      opacity: [0, 1],
      easing: "easeOutQuad",
      duration: 300,
    }).finished;
    player?.play?.();
    preventScroll();
    this.element.classList.add("open");
  },

  async hide() {
    allowScroll();
    await anime({
      targets: this.container.querySelector(".fullscreen-slider"),
      opacity: [1, 0],
      easing: "easeOutQuad",
      duration: 300,
    }).finished;
    this.container.hidden = true;
    this.container.inert = true;
    const iframe = this.container.querySelector("iframe");
    const video = this.container.querySelector("video");
    const player = iframe ? new Player(iframe) : video;
    player?.pause?.();
    this.element.classList.remove("open");
  },

  previous() {
    const index = this.index;
    const length = this.data.array.length;
    const newIndex = (index + length + -1) % length;
    this.index = newIndex;
    this.render();
  },

  next() {
    const index = this.index;
    const length = this.data.array.length;
    const newIndex = (index + length + 1) % length;
    this.index = newIndex;
    console.log(this);
    this.render();
  },

  render() {
    const imageOrVideo = this.data.array[this.index];
    const length = this.data.array.length;
    const caption = imageOrVideo.caption;
    let current;
    if (imageOrVideo.type === "video") {
      current = html` <div data-vimeo-url="${imageOrVideo.url}"></div> `;
    } else {
      current = html`
        <img
          src="${imageOrVideo.src}"
          alt="${imageOrVideo.alt}"
          srcset="${imageOrVideo.srcset}"
          loading="lazy"
        />
      `;
    }
    render(
      this.container,
      html`
        <div class="fullscreen-slider">
          <div class="slider-header">
            <a class="logo" href="/">${window.site.title}</a>
            <h1>${this.data.title}</h1>
            <button
              class="close"
              type="button"
              onclick="${this.handleClickClose.bind(this)}"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-x"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          <div class="slider">
            <div class="slide">
              ${current}
            </div>
            <p>${caption}&nbsp;</p>
            <div class="controls" .hidden="${length < 2}">
              <button type="button" onclick="${this.previous.bind(this)}">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1em"
                  height="1em"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-chevron-left"
                >
                  <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
              </button>
              <button type="button" onclick="${this.next.bind(this)}">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1em"
                  height="1em"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-chevron-right"
                >
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </button>
            </div>
          </div>
          <div class="caption" .hidden="${!this.data.caption.length}">
            ${this.data.caption}
          </div>
        </div>
      `
    );
  },
});
